// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"185f80e4","453":"79373991","455":"de129651","977":"eb332c63"}[chunkId] + ".chunk.js";
};